import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TailSpin } from 'react-loader-spinner';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { Autocomplete, Button, Switch, TextField, Tooltip } from '@mui/material';
import { HexColorPicker } from "react-colorful";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

// Libraries
import SftGlobalData from '../../library/SftGlobalData';
import Colors from '../../library/Colors';
import './eticket.css';
import FloatingSaveButton from '../../components/FloatingSaveButton';
import FloatingBackButton from '../../components/FloatingBackButton';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
  }


const EinvoiceDetailScreen = (props) =>  {
    const [loading, setLoading] = useState(true);
    const [value, setValue] = useState(0);
    const [name, setName] = useState("");
    const [corpId, setCorpId] = useState("00");
    const params = useParams();

    // Template & Colors
    const [template, setTemplate] = useState('2');
    const [templates, setTemplates] = useState([]);
    const [font, setFont] = useState('Montserrat');
    const [color, setColor] = useState(Colors.sft_blue);
    const [textColor, setTextColor] = useState('#FFFFFF');

    // Mail settings
    const [mailFromName, setMailFromName] = useState("");
    const [mailFromEmail, setMailFromEmail] = useState("");
    const [mailSubject, setMailSubject] = useState("");
    const [mailErrorEmail, setMailErrorEmail] = useState("");
    const [accountantEmail, setAccountantEmail] = useState("");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = (val) => !val || val.trim() === '' || emailRegex.test(val.trim());
    const hasEmailErrors = () => !isValidEmail(mailFromEmail) || !isValidEmail(mailErrorEmail) || !isValidEmail(accountantEmail);
    const [accountingPackage, setAccountingPackage] = useState("");

    // Customer toggle
    const [sendToCustomer, setSendToCustomer] = useState(true);

    // Receiver order - array of receiver types in priority order
    const [receiverOrder, setReceiverOrder] = useState([
        { id: 'fact_adres', label: 'Fact adres', enabled: true },
        { id: 'klantemail1', label: 'Klantemail 1', enabled: true },
        { id: 'klantemail2', label: 'Klantemail 2', enabled: true },
        { id: 'custom', label: 'Custom', enabled: true, value: '' }
    ]);
    const [draggedItem, setDraggedItem] = useState(null);

    // Header & Footer
    const [header, setHeader] = useState("");
    const [footer, setFooter] = useState("");
    const [selectedHeaderTag, setSelectedHeaderTag] = useState("");
    const [selectedFooterTag, setSelectedFooterTag] = useState("");

    // Message
    const [message, setMessage] = useState("");
    const [selectedMessageTag, setSelectedMessageTag] = useState("");

    // Peppol toggles
    const [peppolAccountant, setPeppolAccountant] = useState(false);
    const [peppolAccountingPackage, setPeppolAccountingPackage] = useState(false);
    const [peppolRecipient, setPeppolRecipient] = useState(false);

    let navigate = useNavigate();

    useEffect(() => {
        props.changeScreen('E-invoice');
        if(props.api) {
            fetchData();
        }
     },[props.api]);

    const fetchData = () => {
        let postData = {
            sft_id: props.login.sft_status,
            sft_group: props.login.sft_group,
            login: props.login.login,
            key: props.api,
            id: params.listId
        }

        SftGlobalData.post('eticket&action=fetch', postData).then(response => {
            if(response.status == 200){
                // Filter to find the einvoice settings
                const responseData = response.data || [];
                const einvoiceData = responseData.find(item => String(item.service_type).toUpperCase() === 'INVOICE');
                const einvoiceSettings = einvoiceData?.settings || [];
                const setting = einvoiceSettings.find(s => String(s.key) === String(params.elementId));

                let currentTemplateId = "2";
                if(setting) {
                    setName(setting.name || "");
                    setCorpId(setting.corp_id || "00");

                    // Layout
                    currentTemplateId = setting.layout?.template_id || "2";
                    setTemplate(currentTemplateId);
                    setFont(setting.layout?.font || "Montserrat");
                    setColor(setting.layout?.accent_color || Colors.sft_blue);
                    setTextColor(setting.layout?.accent_text_color || "#FFFFFF");

                    // Mail settings
                    setMailFromName(setting.mail_settings?.sender_name || "");
                    setMailFromEmail(setting.mail_settings?.sender_mail || "");
                    setMailSubject(setting.mail_settings?.subject || "");
                    setMailErrorEmail(setting.mail_settings?.error_mail || "");
                    setAccountantEmail(setting.mail_settings?.accountant_email || "");
                    setAccountingPackage(setting.mail_settings?.accounting_package || "");

                    // Customer toggle
                    if(setting.mail_settings?.send_to_customer !== undefined) {
                        setSendToCustomer(setting.mail_settings.send_to_customer === true || setting.mail_settings.send_to_customer === "1");
                    }

                    // Recipient order
                    if(setting.mail_settings?.recipient_order) {
                        setReceiverOrder(setting.mail_settings.recipient_order);
                    }

                    // Header & Footer
                    setHeader(setting.program_vars?.einvoice_header?.replaceAll("<br/>", "\n") || "");
                    setFooter(setting.program_vars?.einvoice_footer?.replaceAll("<br/>", "\n") || "");

                    // Message
                    setMessage(setting.program_vars?.einvoice_message?.replaceAll("<br/>", "\n") || "");

                    // Peppol toggles
                    setPeppolAccountant(setting.peppol_accountant === "1" || setting.peppol_accountant === true);
                    setPeppolAccountingPackage(setting.peppol_accounting_package === "1" || setting.peppol_accounting_package === true);
                    setPeppolRecipient(setting.peppol_recipient === "1" || setting.peppol_recipient === true);
                }

                fetchTemplates(currentTemplateId);
            }
        }).catch(() => {
            setLoading(false);
        });
    }

    const fetchTemplates = (currentTemplate) => {
        let postData = {
            sft_id: props.login.sft_status,
            sft_group: props.login.sft_group,
            login: props.login.login,
            key: props.api,
            type: "EINVOICE",
            active: 1
        }
        SftGlobalData.post('templates&action=fetchHeaders', postData).then(response => {
            const fetchedTemplates = response.data || [];
            setTemplates(fetchedTemplates);

            // Auto-select template if current value is not in the list or if there's only one template
            if(fetchedTemplates.length > 0) {
                const templateExists = fetchedTemplates.some(t => String(t.id) === String(currentTemplate));
                if(!templateExists || fetchedTemplates.length === 1) {
                    setTemplate(String(fetchedTemplates[0].id));
                }
            }

            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const save = () => {
        // Validate custom receiver - must have value if not last
        const customIndex = receiverOrder.findIndex(r => r.id === 'custom');
        const customItem = receiverOrder.find(r => r.id === 'custom');
        if(customIndex < receiverOrder.length - 1 && (!customItem.value || customItem.value.trim() === '')) {
            props.notify("Custom receiver must have a value if not in last position", 7500, "top-right", props.theme, 1);
            return;
        }

        // Email validation
        if(hasEmailErrors()) {
            props.notify(props.t('invalid_email'), 7500, "top-right", props.theme, 1);
            return;
        }

        let postData = {
            sft_group: props.login.sft_group,
            sft_status: props.login.sft_status,
            sft_user_id: props.login.sft_user_id,
            login: props.login.login,
            key: props.api,
            corp_id: corpId,
            id: params.listId,
            element: params.elementId,
            service_type: "einvoice",
            settings: [{
                corp_id: corpId,
                mail_settings: {
                    sender_name: mailFromName,
                    sender_mail: mailFromEmail,
                    subject: mailSubject,
                    error_mail: mailErrorEmail,
                    accountant_email: accountantEmail,
                    accounting_package: accountingPackage,
                    recipient_order: receiverOrder,
                    send_to_customer: sendToCustomer
                },
                layout: {
                    template_id: template,
                    font: font,
                    accent_color: color,
                    accent_text_color: textColor
                }
            }],
            einvoice_header: header.replaceAll("\n", "<br/>"),
            einvoice_footer: footer.replaceAll("\n", "<br/>"),
            einvoice_message: message.replaceAll("\n", "<br/>"),
            peppol_accountant: peppolAccountant,
            peppol_accounting_package: peppolAccountingPackage,
            peppol_recipient: peppolRecipient,
        }

        SftGlobalData.post('eticket&action=wizardEinvoice', postData).then(response => {
            if(response.status == 200){
                props.notify(props.t('savedChanges'), 7500, "top-right", props.theme, 1);
            } else {
                props.notify(props.t('errorOccured'), 7500, "top-right", props.theme, 1);
            }
        });
    }

    /*************************************************************************************
    *                                   MAIL SETTINGS
    *************************************************************************************/
    const tagOptions = [
        // Invoice
        "INVOICE_NR",
        "INVOICE_DATE",
        "DUE_DATE",
        "DELIVERY_DATE",
        "FREE1",
        "REMARK",
        // Customer
        "CUST_FIRST_NAME",
        "CUST_LAST_NAME",
        "CUST_TITLE",
        "CUST_COMPANY",
        "CUST_ADDRESS",
        "CUST_ZIP",
        "CUST_CITY",
        "CUST_COUNTRY",
        "CUST_TELEPHONE",
        "CUST_MOBILE",
        "CUST_EMAIL",
        "CUST_EMAIL2",
        "CUST_TAX",
        // Invoice address
        "CUST_INVOICE_NAME_1",
        "CUST_INVOICE_NAME_2",
        "CUST_INVOICE_ADDRESS_1",
        "CUST_INVOICE_ADDRESS_2",
        "CUST_INVOICE_ZIP",
        "CUST_INVOICE_CITY",
        "CUST_INVOICE_COUNTRY",
        "CUST_INVOICE_EMAIL",
        "CUST_INVOICE_TAX",
        // Corp
        "CORP_DESCRIPTION",
        "CORP_ADDRESS_1",
        "CORP_ADDRESS_2",
        "CORP_ZIP",
        "CORP_CITY",
        "CORP_COUNTRY",
        "CORP_TAX_NUMBER",
        // Store
        "STORE_DESCRIPTION",
        "STORE_SHIPPING_EMAIL",
        // Formatting
        "BULLET",
    ];

    const addTagToHeader = (tag) => {
        if(tag !== ""){
            if(tag === "BULLET") { setHeader(header + "• "); }
            else { setHeader(header + "[" + tag + "] "); }
        }
    };

    const addTagToFooter = (tag) => {
        if(tag !== ""){
            if(tag === "BULLET") { setFooter(footer + "• "); }
            else { setFooter(footer + "[" + tag + "] "); }
        }
    };

    const addTagToMessage = (tag) => {
        if(tag !== ""){
            if(tag === "BULLET") { setMessage(message + "• "); }
            else { setMessage(message + "[" + tag + "] "); }
        }
    };

    const handleDragStart = (e, index) => {
        setDraggedItem(index);
        e.dataTransfer.effectAllowed = 'move';
    };

    const handleDragOver = (e, index) => {
        e.preventDefault();
        if (draggedItem === null || draggedItem === index) return;

        const newOrder = [...receiverOrder];
        const draggedItemContent = newOrder[draggedItem];
        newOrder.splice(draggedItem, 1);
        newOrder.splice(index, 0, draggedItemContent);
        setDraggedItem(index);
        setReceiverOrder(newOrder);
    };

    const handleDragEnd = () => {
        setDraggedItem(null);
    };

    const updateCustomValue = (value) => {
        setReceiverOrder(prev => prev.map(item =>
            item.id === 'custom' ? { ...item, value: value } : item
        ));
    };

    const moveItem = (fromIndex, direction) => {
        const toIndex = direction === 'up' ? fromIndex - 1 : fromIndex + 1;
        if (toIndex < 0 || toIndex >= receiverOrder.length) return;

        const newOrder = [...receiverOrder];
        const item = newOrder.splice(fromIndex, 1)[0];
        newOrder.splice(toIndex, 0, item);
        setReceiverOrder(newOrder);
    };

    const mailStep = () => {
        const customItem = receiverOrder.find(r => r.id === 'custom');
        const customIndex = receiverOrder.findIndex(r => r.id === 'custom');
        const customNeedsValue = customIndex < receiverOrder.length - 1;

        return (
            <div className='rowContainerEvenly' style={{width: '100%'}}>
                <div className='_45perc slide-in-blurred-left'>
                    <h4>{props.t('mail_settings')}</h4>
                    <hr/>

                    <TextField
                        minRows={1}
                        autoComplete="off"
                        className={props.theme + '_accent _100perc'}
                        id="mailFromName"
                        label={props.t('Sender_name')}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': { color: Colors.light_text },
                            '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                            borderRadius: 3, marginTop: 0
                        } : {
                            '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                            '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                            borderRadius: 3, marginTop: 0
                        }}
                        value={mailFromName}
                        onChange={(event) => { setMailFromName(event.target.value) }}
                        required
                    />

                    <TextField
                        minRows={1}
                        autoComplete="off"
                        className={props.theme + '_accent _100perc margin_top_10px'}
                        id="mailFromEmail"
                        label={props.t('Sender_email')}
                        size={'small'}
                        error={!isValidEmail(mailFromEmail)}
                        helperText={!isValidEmail(mailFromEmail) ? props.t('invalid_email') : ''}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': { color: Colors.light_text },
                            '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                            borderRadius: 3
                        } : {
                            '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                            '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                            borderRadius: 3
                        }}
                        value={mailFromEmail}
                        onChange={(event) => { setMailFromEmail(event.target.value) }}
                    />

                    <TextField
                        minRows={1}
                        autoComplete="off"
                        className={props.theme + '_accent _100perc margin_top_10px'}
                        id="mailSubject"
                        label={props.t('subject')}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': { color: Colors.light_text },
                            '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                            borderRadius: 3
                        } : {
                            '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                            '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                            borderRadius: 3
                        }}
                        value={mailSubject}
                        onChange={(event) => { setMailSubject(event.target.value) }}
                    />

                    <TextField
                        minRows={1}
                        autoComplete="off"
                        className={props.theme + '_accent _100perc margin_top_10px'}
                        id="mailErrorEmail"
                        label={props.t('Error_email')}
                        size={'small'}
                        error={!isValidEmail(mailErrorEmail)}
                        helperText={!isValidEmail(mailErrorEmail) ? props.t('invalid_email') : ''}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': { color: Colors.light_text },
                            '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                            borderRadius: 3
                        } : {
                            '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                            '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                            borderRadius: 3
                        }}
                        value={mailErrorEmail}
                        onChange={(event) => { setMailErrorEmail(event.target.value) }}
                    />

                    <div className='rowContainerBetween alignCenterInContainer margin_top_10px'>
                        <TextField
                            minRows={1}
                            autoComplete="off"
                            className={props.theme + '_accent'}
                            style={{flex: 1, marginRight: 10}}
                            id="accountantEmail"
                            label={props.t('accountant')}
                            size={'small'}
                            error={!isValidEmail(accountantEmail)}
                            helperText={!isValidEmail(accountantEmail) ? props.t('invalid_email') : ''}
                            sx={(props.theme==='light') ? {
                                '& .MuiOutlinedInput-input': { color: Colors.light_text },
                                '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                                borderRadius: 3
                            } : {
                                '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                                '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                                borderRadius: 3
                            }}
                            value={accountantEmail}
                            onChange={(event) => { setAccountantEmail(event.target.value) }}
                        />
                        <div style={{display: 'flex', alignItems: 'center', minWidth: 58, justifyContent: 'flex-end'}}>
                            <Tooltip title={props.t('peppol_accountant_tooltip')} arrow placement="top">
                                <Switch
                                    size="small"
                                    checked={peppolAccountant}
                                    onChange={(event) => { setPeppolAccountant(event.target.checked) }}
                                    inputProps={{ 'aria-label': 'peppol accountant' }}
                                />
                            </Tooltip>
                        </div>
                    </div>

                    <div className='rowContainerBetween alignCenterInContainer margin_top_10px'>
                        <TextField
                            minRows={1}
                            autoComplete="off"
                            className={props.theme + '_accent'}
                            style={{flex: 1, marginRight: 10}}
                            id="accountingPackage"
                            label={props.t('accounting_package')}
                            size={'small'}
                            sx={(props.theme==='light') ? {
                                '& .MuiOutlinedInput-input': { color: Colors.light_text },
                                '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                                borderRadius: 3
                            } : {
                                '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                                '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                                borderRadius: 3
                            }}
                            value={accountingPackage}
                            onChange={(event) => { setAccountingPackage(event.target.value) }}
                        />
                        <div style={{display: 'flex', alignItems: 'center', minWidth: 58, justifyContent: 'flex-end'}}>
                            <Tooltip title={props.t('peppol_accounting_package_tooltip')} arrow placement="top">
                                <Switch
                                    size="small"
                                    checked={peppolAccountingPackage}
                                    onChange={(event) => { setPeppolAccountingPackage(event.target.checked) }}
                                    inputProps={{ 'aria-label': 'peppol accounting package' }}
                                />
                            </Tooltip>
                        </div>
                    </div>

                    <div style={{marginTop: 10, marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <div>
                            <span style={{fontSize: 13, fontWeight: 500}}>{props.t('recipients')}</span>
                            <span style={{fontSize: 11, color: Colors.def_grey, marginLeft: 8}}>({props.t('drag_to_reorder')})</span>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', gap: 4}}>
                            <span style={{fontSize: 11, color: Colors.def_grey}}>{props.t('send_to_customer')}</span>
                            <Switch
                                size="small"
                                checked={sendToCustomer}
                                onChange={(event) => { setSendToCustomer(event.target.checked) }}
                                inputProps={{ 'aria-label': 'send to customer' }}
                            />
                        </div>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 8, opacity: sendToCustomer ? 1 : 0.35, pointerEvents: sendToCustomer ? 'auto' : 'none'}}>
                        {receiverOrder.map((item, index) => (
                            <div
                                key={item.id}
                                className='rowContainerBetween alignCenterInContainer'
                            >
                                <div
                                    draggable
                                    onDragStart={(e) => handleDragStart(e, index)}
                                    onDragOver={(e) => handleDragOver(e, index)}
                                    onDragEnd={handleDragEnd}
                                    className={props.theme + '_accent'}
                                    style={{
                                        flex: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '0 14px',
                                        borderRadius: 4,
                                        cursor: 'grab',
                                        border: draggedItem === index
                                            ? '2px dashed ' + Colors.sft_blue
                                            : '1px solid ' + (props.theme === 'dark' ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'),
                                        transition: 'all 0.2s ease',
                                        marginRight: 10,
                                        height: 40,
                                        boxSizing: 'border-box'
                                    }}
                                >
                                    <span style={{
                                        marginRight: 12,
                                        fontWeight: 'bold',
                                        color: Colors.sft_blue,
                                        minWidth: 20
                                    }}>
                                        {index + 1}.
                                    </span>
                                    <span style={{flex: 1}}>{item.label}</span>

                                    {item.id === 'custom' && (
                                        <TextField
                                            size="small"
                                            placeholder={customNeedsValue ? props.t('required') : props.t('optional')}
                                            value={customItem?.value || ''}
                                            onChange={(e) => updateCustomValue(e.target.value)}
                                            onClick={(e) => e.stopPropagation()}
                                            onMouseDown={(e) => e.stopPropagation()}
                                            draggable={false}
                                            error={customNeedsValue && !customItem?.value}
                                            sx={{
                                                width: 220,
                                                marginRight: 1,
                                                '& .MuiOutlinedInput-input': {
                                                    color: props.theme === 'light' ? Colors.light_text : Colors.dark_text,
                                                    padding: '6px 10px'
                                                }
                                            }}
                                        />
                                    )}

                                    <div style={{display: 'flex', gap: 4}}>
                                        <button
                                            onClick={(e) => { e.stopPropagation(); moveItem(index, 'up'); }}
                                            disabled={index === 0}
                                            style={{
                                                padding: '4px 8px',
                                                cursor: index === 0 ? 'not-allowed' : 'pointer',
                                                opacity: index === 0 ? 0.3 : 1,
                                                border: 'none',
                                                borderRadius: 4,
                                                backgroundColor: Colors.sft_blue,
                                                color: 'white'
                                            }}
                                        >
                                            ▲
                                        </button>
                                        <button
                                            onClick={(e) => { e.stopPropagation(); moveItem(index, 'down'); }}
                                            disabled={index === receiverOrder.length - 1}
                                            style={{
                                                padding: '4px 8px',
                                                cursor: index === receiverOrder.length - 1 ? 'not-allowed' : 'pointer',
                                                opacity: index === receiverOrder.length - 1 ? 0.3 : 1,
                                                border: 'none',
                                                borderRadius: 4,
                                                backgroundColor: Colors.sft_blue,
                                                color: 'white'
                                            }}
                                        >
                                            ▼
                                        </button>
                                    </div>
                                </div>
                                <div style={{display: 'flex', alignItems: 'center', minWidth: 58, justifyContent: 'flex-end'}}>
                                    {index === 0 ? (
                                        <Tooltip title={props.t('peppol_recipient_tooltip')} arrow placement="top">
                                            <Switch
                                                size="small"
                                                checked={peppolRecipient}
                                                onChange={(event) => { setPeppolRecipient(event.target.checked) }}
                                                inputProps={{ 'aria-label': 'peppol recipient' }}
                                            />
                                        </Tooltip>
                                    ) : (
                                        <div style={{width: 58}}></div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className='_45perc slide-in-blurred-right'>
                    <h4>{props.t('message')}</h4>
                    <hr/>

                    <TextField
                        multiline
                        rows={10}
                        autoComplete="off"
                        className={props.theme + '_accent _100perc margin_top_10px'}
                        id="message"
                        label={props.t('message')}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': { color: Colors.light_text },
                            '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                            borderRadius: 3
                        } : {
                            '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                            '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                            borderRadius: 3
                        }}
                        value={message}
                        onChange={(event) => { setMessage(event.target.value.replaceAll("&bull;", "•").replaceAll("[BULLET]", "•")) }}
                    />

                    <div className="rowContainerBetween margin_top_10px" style={{alignItems: 'center'}}>
                        <Autocomplete
                            options={tagOptions}
                            value={selectedMessageTag || null}
                            onChange={(event, newValue) => { setSelectedMessageTag(newValue || ""); }}
                            renderInput={(params) => <TextField {...params} label="Tags" size="small" />}
                            className={props.theme + "_accent"}
                            style={{ flex: 1, marginRight: 10 }}
                            size="small"
                        />
                        <Button type="button" className={"button_container__button_no_margin width_120px maxHeight"} onClick={() => { addTagToMessage(selectedMessageTag); }}>&nbsp;{props.t('add')}&nbsp;</Button>
                    </div>
                </div>
            </div>
        );
    }

    /*************************************************************************************
    *                                HEADER & FOOTER
    *************************************************************************************/
    const headerFooterStep = () => {
        return (
            <div className='rowContainerBetween'>
                <div className="_45perc slide-in-blurred-left">
                    <h4>{props.t('header')}</h4>
                    <div className="rowContainerStart">
                        <textarea className={"textareaBorderRight "+ ((props.theme==='light') ? 'light_accent_darker textarea' : 'dark_accent textarea')} id="einvoice_header" onChange={(event)=>{setHeader(event.target.value.replaceAll("&bull;", "•").replaceAll("[BULLET]", "•"))}} name="header" value={header} style={{resize: 'none', minHeight: 245}}/>
                    </div>
                    <div className="rowContainerBetween margin_bottom_10px" style={{alignItems: 'center'}}>
                        <Autocomplete
                            options={tagOptions}
                            value={selectedHeaderTag || null}
                            onChange={(event, newValue) => { setSelectedHeaderTag(newValue || ""); }}
                            renderInput={(params) => <TextField {...params} label="Tags" size="small" />}
                            className={props.theme + "_accent _80perc"}
                            size="small"
                        />
                        <Button type="button" className={"button_container__button_no_margin width_120px maxHeight "} onClick={()=>{addTagToHeader(selectedHeaderTag)}}>&nbsp;{props.t('add')}&nbsp;</Button>
                    </div>
                </div>
                <div className="_45perc slide-in-blurred-right">
                    <h4>{props.t('footer')}</h4>
                    <div className="rowContainerEnd">
                        <textarea className={"textareaBorderRight "+ ((props.theme==='light') ? 'light_accent_darker textarea' : 'dark_accent textarea')} id="einvoice_footer" onChange={(event)=>{setFooter(event.target.value.replaceAll("&bull;", "•").replaceAll("[BULLET]", "•"))}} name="footer" value={footer} style={{resize: 'none', minHeight: 245}}/>
                    </div>
                    <div className="rowContainerBetween margin_bottom_10px" style={{alignItems: 'center'}}>
                        <Autocomplete
                            options={tagOptions}
                            value={selectedFooterTag || null}
                            onChange={(event, newValue) => { setSelectedFooterTag(newValue || ""); }}
                            renderInput={(params) => <TextField {...params} label="Tags" size="small" />}
                            className={props.theme + "_accent _80perc"}
                            size="small"
                        />
                        <Button type="button" className={"button_container__button_no_margin width_120px maxHeight "} onClick={()=>{addTagToFooter(selectedFooterTag)}}>&nbsp;{props.t('add')}&nbsp;</Button>
                    </div>
                </div>
            </div>
        );
    }

        /*************************************************************************************
    *                             TEMPLATE / COLORS
    *************************************************************************************/
    const templateStep = () => {
        return (
            <div className="rowContainerEvenly" style={{width: '100%'}}>
                <div className='margin_top_10px columnContainerBetween slide-in-blurred-left' style={{width: '25%'}}>
                    <FormControl className={props.theme + '_accent _100perc'}>
                        <InputLabel id="template-select-label">{props.t('template')}</InputLabel>
                        <Select
                            className={props.theme + "_accent " + props.theme + "_text _100perc"}
                            labelId="template-select-label"
                            id="template-select"
                            value={template}
                            label="Template"
                            onChange={(event) => { setTemplate(event.target.value); }}
                            style={{height: 40, paddingTop: 8, paddingBottom: 8}}>
                            {templates.map((tmpl) => (
                                <MenuItem key={tmpl.id} value={tmpl.id}>
                                    {tmpl.title}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl className={props.theme + '_accent _100perc'}>
                        <InputLabel id="font-select-label">{props.t('font')}</InputLabel>
                        <Select
                            className={props.theme + "_accent " + props.theme + "_text _100perc"}
                            labelId="font-select-label"
                            id="font-select"
                            value={font}
                            label={props.t('font')}
                            onChange={(event) => { setFont(event.target.value); }}
                            style={{height: 40, paddingTop: 8, paddingBottom: 8}}>
                            <MenuItem value={"Arial"}>Arial</MenuItem>
                            <MenuItem value={"Brush Script MT"}>Brush Script MT</MenuItem>
                            <MenuItem value={"Comic Sans MS"}>Comic Sans MS</MenuItem>
                            <MenuItem value={"Courier New"}>Courier New</MenuItem>
                            <MenuItem value={"Georgia"}>Georgia</MenuItem>
                            <MenuItem value={"Garamond"}>Garamond</MenuItem>
                            <MenuItem value={"Montserrat"}>Montserrat</MenuItem>
                            <MenuItem value={"Open Sans"}>Open Sans</MenuItem>
                            <MenuItem value={"'Times New Roman'"}>Times New Roman</MenuItem>
                            <MenuItem value={"Verdana"}>Verdana</MenuItem>
                        </Select>
                    </FormControl>
                    <p style={{fontFamily: font, textAlign: 'center', backgroundColor: color, color: textColor, width: '100%', marginBottom: 1}}> <br/> {props.t('example_text')} <br/> &nbsp;</p>
                </div>
                <div className='margin_top_10px columnContainerBetween slide-in-blurred-top' style={{width: '25%'}}>
                    <TextField
                        minRows={1}
                        autoComplete="off"
                        className={props.theme + '_accent _100perc'}
                        id="accent_color"
                        label={props.t('accent_color')}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': { color: Colors.light_text },
                            '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                            borderRadius: 3, marginTop: 0
                        } : {
                            '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                            '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                            borderRadius: 3, marginTop: 0
                        }}
                        value={color.toUpperCase()}
                        onChange={(event) => { setColor(event.target.value) }}
                        required
                    />
                    <section className="resposive example margin_top_15px">
                        <HexColorPicker className="colorpicker" color={color} onChange={(event) => { setColor(event); }} />
                    </section>
                </div>
                <div className='margin_top_10px columnContainerBetween slide-in-blurred-right' style={{width: '25%'}}>
                    <TextField
                        minRows={1}
                        autoComplete="off"
                        className={props.theme + '_accent _100perc'}
                        id="text_color"
                        label={props.t('text_color')}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': { color: Colors.light_text },
                            '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                            borderRadius: 3, marginTop: 0
                        } : {
                            '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                            '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                            borderRadius: 3, marginTop: 0
                        }}
                        value={textColor.toUpperCase()}
                        onChange={(event) => { setTextColor(event.target.value) }}
                        required
                    />
                    <section className="resposive example margin_top_15px">
                        <HexColorPicker className="colorpicker" color={textColor} onChange={(event) => { setTextColor(event); }} />
                    </section>
                </div>
            </div>
        );
    }

    return (
        <div className={(props.screenWidth) < 600 ? 'not_expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme : 'expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme}>
            <FloatingBackButton onClick={() => { navigate("/" + props.lang + "/eticket"); }} />
            <FloatingSaveButton disabled={hasEmailErrors()} onClick={() => { save(); }} />

            <div className={"container_list__title " + props.theme}>
                <h2>E-invoice - {name} {corpId !== "00" ? `(Corp: ${corpId})` : "(Default)"}</h2>
            </div>

            <br/><br/><br/><br/><br/>

            {loading && (
                <div className="rowContainerCenter">
                    <TailSpin
                        height="80"
                        width="80"
                        color={Colors.sft_blue}
                        ariaLabel='loading'
                    />
                </div>
            )}

            {!loading && (
                <Box className={props.theme + ' _100perc'}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className={props.theme + ' container_tabs_below_subtitle'}>
                        <Tabs value={value} onChange={handleChange} className={props.theme} variant="scrollable" scrollButtons="auto">
                            <Tab label={props.t('mail_settings')} {...a11yProps(0)} className={props.theme}/>
                            <Tab label={props.t('header') + ' & ' + props.t('footer')} {...a11yProps(1)} className={props.theme}/>
                            <Tab label={props.t('template')} {...a11yProps(2)} className={props.theme}/>
                        </Tabs>
                    </Box>

                    <TabPanel value={value} index={0}>
                        {mailStep()}
                    </TabPanel>

                    <TabPanel value={value} index={1}>
                        {headerFooterStep()}
                    </TabPanel>

                    <TabPanel value={value} index={2}>
                        {templateStep()}
                    </TabPanel>
                </Box>
            )}
        </div>
    );
}

export default EinvoiceDetailScreen;
